import { render, staticRenderFns } from "./ListTransport.vue?vue&type=template&id=01485564&scoped=true&"
import script from "./ListTransport.vue?vue&type=script&lang=js&"
export * from "./ListTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01485564",
  null
  
)

export default component.exports